import {createContext} from 'react';

/**
 * Provides the current wizard step identifier to descendants.
 * This boundary is used to associate fields with a step, even when steps are
 * rendered both offscreen (for validation/error collection) and visibly (for UI).
 * Consumers can call `useWizardStepId()` to read the current step id.
 */
export const WizardStepContext = createContext<string | null>(null);
